import styled, { css } from 'styled-components';

export const alignCenter = css`
  display: flex;
  align-items: center;
`;

export const HeadingWrapper = styled.div`
  padding-top: 3rem;
`;

export const LineWrapper = styled.div`
  ${alignCenter};
  margin-bottom: 0.5rem;
`;

export const DetailWrapper = styled.div`
  ${alignCenter};
  align-items: flex-start;
  margin-bottom: 1rem;
`;

export const LeftParagraphWrapper = styled.div`
  margin-right: 0.5rem;
`;

export const LeftIcon = styled.img`
  margin-right: 0.5rem;
  max-height: 16px;
`;

export const SynchronizeArrowsImg = styled.img`
  margin-right: 0.5rem;
  max-height: 16px;
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
`;
